﻿import { createContext, useContext } from 'react';

import { StudentGroup, StudentGroupWithDetails } from 'apis/StudentGroupApi';
import { DEFAULT_TAB_CONTEXT, TabsContext } from 'components/Tabs';
import type { StudentPermissions } from 'pages/students/types';
import { StudentWithDetails } from 'apis/StudentApi';
import { AccessCode } from 'apis/AccessCodeApi';
import { Country } from 'apis/CountryApi';
import { State } from 'apis/StateApi';

export interface StudentData {
    accessCodes?: AccessCode[];
    activity?: any;
    groups?: StudentGroupWithDetails[];
    performance?: any;
    states?: State[];
    studentWithDetails?: StudentWithDetails;
    studentWithDetailsOriginal?: StudentWithDetails;
}

interface StudentsContextValue {
    countries: Country[];
    groupsWindow?: Window;
    permissions: StudentPermissions;
    setGroupsWindow: (window: Window) => void;
    setTransactionsWindow: (window: Window) => void;
    studentGroups: StudentGroup[];
    transactionsWindow?: Window;
}

export const StudentDetailsContext = createContext<TabsContext<StudentData>>(DEFAULT_TAB_CONTEXT);
StudentDetailsContext.displayName = 'StudentDetailsContext';

export const StudentsContext = createContext<StudentsContextValue>({
    countries: [],
    permissions: {
        ArchivedStudents: false,
        CourseReporting: false,
        CustomFieldsFlag: false,
        Edit: false,
        EditPII: false,
        EditUsername: false,
        GroupPermission: false,
        Import: false,
        IsPostFiltering: false,
        Login: false,
        Merge: false,
        NewFieldAccess: false,
        OverviewPermission: false,
        PartnerId: 0,
        PartnerType: 0,
        Search: false,
        TransactionFeatureFlag: false,
        TransactionPermission: false,
        ViewPII: false
    },
    setGroupsWindow: () => {

        //
    },
    setTransactionsWindow: () => {

        //
    },
    studentGroups: []
});
StudentsContext.displayName = 'StudentsContext';

export const useStudents = () => useContext(StudentsContext);
